import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#2f3e6d',
        secondary: '#E68019',
        tertiary: '#FF5757',
        accent: '#7AABCC',
        error: '#EB2142',
        info: '#7AABCC',
        background: '#F7FAFE',
        success: '#4caf50',
        warning: '#FFC107',
        caution: '#FF5757',
        language: '#49D219',
        data: '#CBC74E',
        skill: '#FF5757',
        tool: '#FF5757',
        header: '#F0F6F9',
        regular: '#CBC74E',
        side: '#FF5757',
        requestApplication: '#FF5757',
        selfApplication: '#CBC74E',
        submission: '#CBC74E',
        grade: '#FF5757',
        gray: '#808080',
      }
    }
  }
});
